import api from '@/api'
import types from './peopleTypes.js'

const actions = {
  async getAccounts(context, payload) {
    const options = {}

    options.filters = payload.filters || {}
    options.sort = {
      by: payload?.sort?.by ?? 'updatedTimestamp',
      order: payload?.sort?.order ?? 'desc',
    }

    if (payload.terms) options.terms = payload.terms || ''
    if (payload.startAfter) options.startAfter = payload.startAfter
    if (payload.startBefore) options.startBefore = payload.startBefore
    if (payload.limit) options.limit = payload.limit
    if (payload.from) options.from = payload.from

    const response = await api.account.getAccounts(
      payload.organizationId,
      options
    )
    return response.data
  },

  async createAccount(context, payload) {
    try {
      const { account, organizationId } = payload
      context.dispatch('showLoader')

      const response = await api.account.create(organizationId, account)
      return response.data
    } finally {
      context.dispatch('hideLoader')
    }
  },

  async updateAccount(context, payload) {
    const { data, account } = payload
    const accountId = account._id
    const organizationId = account.organization._id || account.organization

    const response = await api.account.update(organizationId, accountId, data)
    return response.data
  },

  toggleFinancialPermission: function(context, payload) {
    const organizationId = payload.organizationId
    const accountId = payload.accountId

    const data = {
      canDoFinancialValidation: payload.canDoFinancialValidation,
    }

    return api.account
      .update(organizationId, accountId, data)
      .then(response => {
        return response.data
      })
  },

  deleteAccount: function(context, payload) {
    context.dispatch('showLoader')

    const organizationId = payload.organizationId
    const accountId = payload.accountId

    return api.account
      .delete(organizationId, accountId)
      .then(() => {
        context.dispatch('hideLoader')
      })
      .catch(() => {
        context.dispatch('hideLoader')
      })
  },

  fetchAccount: async function(context, payload) {
    const account = await api.account.getById(
      payload.organizationId,
      payload.accountId
    )
    return account.data
  },

  getAccount: function(context, payload) {
    context.dispatch('showLoader')
    context.commit(types.CLEAR_PROFILE)

    return api.account
      .getById(payload.organizationId, payload.accountId)
      .then(response => {
        const profile = {
          _id: response.data._id,
          organization: response.data.organization,
          displayname: response.data.displayname,
          familyname: response.data.familyname,
          email: response.data.email,
          reverScore: response.data.reverScore,
          jobPosition: response.data.jobPosition,
          photo: response.data.photo,
          site: response.data.site,
          tags: response.data.tags,
        }

        context.commit(types.SET_PROFILE, {
          profile: profile,
        })

        return response.data
      })
      .catch(error => {
        context.dispatch('hideLoader')
        console.log(error)
        return error
      })
  },
}

export default actions
